import axios from 'axios'

const BASE_URL = process.env.VUE_APP_API_BASE_URL
const API_URL = BASE_URL + 'admin-role'
const PrivilegeAPIURL = API_URL + '/privilege'

class AdminRoleService {
  getAdminRoles () {
    return axios.get(API_URL, { showLoader: false })
  }

  getAdminRoleById (RoleId) {
    return axios.get(API_URL + '/' + RoleId)
  }

  removeAdminRoleById (RoleId) {
    return axios.delete(API_URL + '/' + RoleId)
  }

  createOrUpdateAdminRole (AdminRole, PrivilegeIds) {
    const data = {
      AdminRole,
      PrivilegeIds
    }
    return axios.post(API_URL, data)
  }

  getAdminRolePrivilegeIdsByAdminRoleId (RoleId) {
    return axios.get(API_URL + '/' + RoleId + '/privilege/list')
  }

  getAdminRolePrivileges () {
    return axios.get(PrivilegeAPIURL + '/list')
  }
}

export default new AdminRoleService()
